import { getStyles } from '@kubit/web-ui-components/utils/getStyles';
import styled from 'styled-components';
export const ProgressBarComplexContainerStyled = styled.div `
  ${props => getStyles(props.styles?.container)}
`;
export const MultipleProgressBarsContainerStyled = styled.div `
  ${props => getStyles(props.styles?.multipleProgressBarsContainer)}
`;
export const ParentMultipleProgressBarsContainerStyled = styled.div `
  ${props => getStyles(props.styles?.parentMultipleProgressBarsContainer)}
`;
//# sourceMappingURL=progressBarComplex.styled.js.map